import React, { Fragment } from 'react'

import Account_RequestIcon from 'custom/assets/accounts/Request.svg'
import Account_Beneficiary_TransferIcon from 'custom/assets/accounts/Beneficiary_Transfer.svg'
import Account_PaymentIcon from 'custom/assets/accounts/Payment.svg'
import Account_Quick_TransferIcon from 'custom/assets/accounts/Quick_Transfer.svg'
import Account_Set_account_nameIcon from 'custom/assets/accounts/Set_account_name.svg'
import Account_StatementIcon from 'custom/assets/accounts/Statement.svg'
import Account_DepositIcon from 'custom/assets/accounts/Deposit.svg'
import Account_LoanIcon from 'custom/assets/accounts/Loan.svg'
import Account_SIIcon from 'custom/assets/accounts/SI.svg'
import Approval_DepositsIcon from 'custom/assets/approvals/deposit.svg'
import Approval_BeneIcon from 'custom/assets/approvals/Beneficiaries.svg'
import Approval_ChequeBookIcon from 'custom/assets/approvals/Chequebook.svg'
import Approval_FundIcon from 'custom/assets/approvals/FundTransfer.svg'
import Approval_PaymentIcon from 'custom/assets/approvals/Payment.svg'
import Approval_SalaryUploadIcon from 'custom/assets/approvals/SalaryUpload.svg'
import Approval_SIIcon from 'custom/assets/approvals/Standing_Instruction.svg'
import Approval_StopChequeIcon from 'custom/assets/approvals/StopChequePayment.svg'
import { ACCOUNTS_MENU_KEYS, APPROVAL_MENU_KEYS ,HISTORY_MENU_KEYS} from '../utils/translation-constants'
import Account_CardlessCashIcon from "custom/assets/accounts/Cardless_Cash.svg"
import Approval_DebitCardIcon from "custom/assets/approvals/RequestCard.svg"
import Approval_BlockCardIcon from "custom/assets/approvals/BlockCard.svg"

export const APPROVAL_SUB_MENUS = {
  TITLE: {
    STPCHQP: APPROVAL_MENU_KEYS.STOP_CHEQUE,
    SIP: APPROVAL_MENU_KEYS.STANDING_INSTRUCTION,
    BILLPAYMENTP: APPROVAL_MENU_KEYS.PAYMENTS,
    CHQBOOKP: APPROVAL_MENU_KEYS.CHEQUE_BOOK,
    FTP: APPROVAL_MENU_KEYS.FUND_TRANSFER,
    SALARYUPLOADP: APPROVAL_MENU_KEYS.SALARY_UPLOAD,
    BENEFTP: APPROVAL_MENU_KEYS.BENEFICIARY,
    TERMDEPOSITP: APPROVAL_MENU_KEYS.TERM_DEPOSIT,
    CARDLESSCASHP:ACCOUNTS_MENU_KEYS.CARD_LESS_CASH,
    DEBITCARDP: APPROVAL_MENU_KEYS.DEBIT_CARD,
    CARDSTATUSCHANGEP: APPROVAL_MENU_KEYS.BLOCK_CARD,
  },
  NOTIFICATION_POINT: {
    'Stop Cheque': 'stopChequeData',
    'Standing Instruction': 'siData',
    'Payments': 'billpayments',
    'Cheque Book': 'chequeBookData',
    'Fund Transfer': 'fundtransfersData',
    'File Upload': 'salaryUpload',
    'Beneficiaries': 'beneficiary',
    'Deposits': 'termDeposit',
    'CardLess Cash':'cardlessCashout',
    'Debit Card': 'debitCard'
  },
  LINKS: {
    STPCHQP: '/approvals/stopCheque',
    SIP: '/approvals/si',
    BILLPAYMENTP: '/approvals/payments',
    CHQBOOKP: '/approvals/chequeBook',
    FTP: '/approvals/ft',
    SALARYUPLOADP: '/approvals/salaryUpload',
    BENEFTP: '/approvals/beneficiaries',
    TERMDEPOSITP: '/approvals/td',
    CARDLESSCASHP:'/approvals/cardLessCash',
    DEBITCARDP: '/approvals/debitCard',
    CARDSTATUSCHANGEP: '/approvals/blockCard'

  },

  ICONS: {
    STPCHQP: Approval_StopChequeIcon,
    SIP: Approval_SIIcon,
    BILLPAYMENTP: Approval_PaymentIcon,
    CHQBOOKP: Approval_ChequeBookIcon,
    FTP: Approval_FundIcon,
    SALARYUPLOADP: Approval_SalaryUploadIcon,
    BENEFTP: Approval_BeneIcon,
    TERMDEPOSITP: Approval_DepositsIcon,
    CARDLESSCASHP:Account_CardlessCashIcon,
    DEBITCARDP: Approval_DebitCardIcon,
    CARDSTATUSCHANGEP:Approval_BlockCardIcon
  },
}

export const HISTORY_SUB_MENUS = {
  TITLE: {
    STPCHQC: HISTORY_MENU_KEYS.STOP_CHEQUE,
    SIC: HISTORY_MENU_KEYS.STANDING_INSTRUCTION,
    BILLPAYMENTC: HISTORY_MENU_KEYS.PAYMENTS,
    CHQBOOKC: HISTORY_MENU_KEYS.CHEQUE_BOOK,
    FTC: HISTORY_MENU_KEYS.FUND_TRANSFER,
    SALARYUPLOADC: HISTORY_MENU_KEYS.SALARY_UPLOAD,
    BENEFTC: HISTORY_MENU_KEYS.BENEFICIARY,
    TERMDEPOSITC: HISTORY_MENU_KEYS.TERM_DEPOSIT,
    CARDLESSCASHC:HISTORY_MENU_KEYS.CARDLESS_CASH,
    DEBITCARDC: HISTORY_MENU_KEYS.DEBIT_CARD,
    CARDSTATUSCHANGEC: HISTORY_MENU_KEYS.BLOCK_CARD
  },
  LINKS: {
    STPCHQC: '/history/stopCheque',
    SIC: '/history/si',
    BILLPAYMENTC: '/history/payments',
    CHQBOOKC: '/history/chequeBook',
    FTC: '/history/ft',
    SALARYUPLOADC: '/history/salaryUpload',
    BENEFTC: '/history/beneficiaries',
    TERMDEPOSITC: '/history/td',
    CARDLESSCASHC:'/history/cardLessCash',
    DEBITCARDC: '/history/debitCard',
    CARDSTATUSCHANGEC: '/history/blockCard'
  },

  ICONS: {
    STPCHQC: Approval_StopChequeIcon,
    SIC: Approval_SIIcon,
    BILLPAYMENTC: Approval_PaymentIcon,
    CHQBOOKC: Approval_ChequeBookIcon,
    FTC: Approval_FundIcon,
    SALARYUPLOADC: Approval_SalaryUploadIcon,
    BENEFTC: Approval_BeneIcon,
    TERMDEPOSITC: Approval_DepositsIcon,
    DEBITCARDC: Approval_DebitCardIcon,
    CARDLESSCASHC:Account_CardlessCashIcon,
    CARDSTATUSCHANGEC:Approval_BlockCardIcon,
  },
}

export const ACCOUNT_SUB_MENUS = {
  TITLE: {
    DACCOUNTS: ACCOUNTS_MENU_KEYS.DEPOSITS,
    SIACCOUNTS: ACCOUNTS_MENU_KEYS.SI,
    LACCOUNTS: ACCOUNTS_MENU_KEYS.LOANS,
    BILLPAYMENT: ACCOUNTS_MENU_KEYS.PAYMENTS,
    INSTANTFT: ACCOUNTS_MENU_KEYS.QUICK_PAY,
    REQUESTS: ACCOUNTS_MENU_KEYS.REQUESTS,
    BILLPAYMENTI: ACCOUNTS_MENU_KEYS.PAYMENTS,
    FTI: ACCOUNTS_MENU_KEYS.QUICK_PAY,
    BENE: ACCOUNTS_MENU_KEYS.BENEFICIARY_TRANSFERS,
    CARDLESSCASHI:ACCOUNTS_MENU_KEYS.CARD_LESS_CASH
  },
  LINKS: {
    DACCOUNTS: '/deposit-view',
    SIACCOUNTS: 'accounts/standing-instruction',
    LACCOUNTS: '/loans-view',
    BILLPAYMENT: '/payments',
    INSTANTFT: '/quick-pay',
    REQUESTS: '/requests',
    BILLPAYMENTI: '/payments',
    FTI: '/accounts/quick-pay',
    BENE: '/transfers/beneficiary-transfers',
    CARDLESSCASHI:'/cardLessCash'
  },
  ICONS: {
    DACCOUNTS: Account_DepositIcon,
    SIACCOUNTS: Account_SIIcon,
    LACCOUNTS: Account_LoanIcon,
    BILLPAYMENT: Account_PaymentIcon,
    INSTANTFT: Account_Quick_TransferIcon,
    REQUESTS: Account_RequestIcon,
    BILLPAYMENTI: Account_PaymentIcon,
    FTI: Account_Quick_TransferIcon,
    BENE: Account_Beneficiary_TransferIcon,
    STATEMENTS: Account_StatementIcon,
    SET_ACCOUNT_NAME: Account_Set_account_nameIcon,
    SEND_TO_WALLET: Account_Quick_TransferIcon,
    CARDLESSCASHI:Account_CardlessCashIcon
  },
  DESCRIPTION: {
    DACCOUNTS: ACCOUNTS_MENU_KEYS.DEPOSITS_DESCRIPTION,
    SIACCOUNTS: ACCOUNTS_MENU_KEYS.SI_DESCRIPTION,
    LACCOUNTS: ACCOUNTS_MENU_KEYS.LOANS_DESCRIPTION,
    BILLPAYMENT: ACCOUNTS_MENU_KEYS.PAYMENTS_DESCRIPTION,
    INSTANTFT: ACCOUNTS_MENU_KEYS.QUICK_PAY_DESCRIPTION,
    REQUESTS: ACCOUNTS_MENU_KEYS.REQUESTS_DESCRIPTION,
    BILLPAYMENTI: ACCOUNTS_MENU_KEYS.PAYMENTS_DESCRIPTION,
    FTI: ACCOUNTS_MENU_KEYS.QUICK_PAY_DESCRIPTION,
    BENE: ACCOUNTS_MENU_KEYS.BENEFICIARY_TRANSFERS_DESCRIPTION,
    CARDLESSCASHI:ACCOUNTS_MENU_KEYS.CARD_LESS_CASH_DESCRIPTION
  },
}
